import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import { TimeConstants } from '../../../constants/time';
import type { Recipe } from '../../../type';
import { handleError } from '../../../utils/common';
import { useAlertModal } from '../../../utils/hook/hook';
import { RecipeApi } from '../recipe.api';

/** 이 달의 추천 레시피 섹션 제목 */
export const MONTHLY_RECOMMENDED_TITLE = '이 달의 추천 레시피';

/**
 * 이 달의 추천 레시피 목록을 조회하는 React Query 훅
 */
export const useMonthlyRecommendedRecipesQuery = (
  options?: Omit<UseQueryOptions<Recipe[]>, 'queryKey' | 'queryFn' | 'meta'>,
) => {
  const { openAlertModal } = useAlertModal();

  const queryResult = useQuery({
    queryKey: RecipeApi.queryKeys.monthlyRecommendedRecipes(),
    queryFn: () => RecipeApi.getMonthlyRecommendedRecipes(),
    staleTime: TimeConstants.FIVE_MINUTES,
    meta: {
      onError: (error: unknown) =>
        handleError(openAlertModal, error, '이 달의 추천 레시피 조회'),
    },
    ...options,
  });

  return {
    monthlyRecommendedRecipes: queryResult.data ?? [],
    ...queryResult,
  };
};
